module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国中央警卫营旧址.c4f14743.png";